import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import { FieldArray } from 'react-final-form-arrays';
import { OnChange, OnFocus } from 'react-final-form-listeners';
import * as actions from '../../actions';
import { 
    isRequiredSelectionCheckbox,
    isRequiredSignature,
    isRequiredText,
    conditionallyRequiredSignature,
    conditionallyRequiredSelectionCheckbox,
    isRequiredTextarea,
    isRequiredSelection,
    isRequiredQuestionSelection
} from '../helpers/Validation';
import SignatureCanvas from 'react-signature-canvas';
import { camelCase } from 'lodash';
import { stateList, textField, textareaField } from '../helpers/Form';
import SignatureDate from '../hooks/SignatureDate';

const conditionalCheckboxes = [
    "Number of refills",
    "Number of days to be dispensed",
    "Other"
];

const conditionalTextareas = [
    "numberOfRefillsText",
    "numberOfDaysToBeDispensedText",
    "otherText",
    "otherTextFree"
];

class Step4 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            confirmDiagnosis: null,
            confirmDiagnosisOther: null,
            prescriberAgentSignatureTwo: null,
            prescriberAgentSignatureThree: null,
            prescriberAgentSignatureFour: null,
            sigTakeOneFreeOther: null,
            dispenseThirtyDays: false,
            otherPrescriptions:false,
            otherTextFreeShow:false,
            otherTextFreeDoseShow:false,
            ongoingPrescriptionFree: null,
            ongoingPrescriptionFreeDose: null
            
        }
    }

    // Used to restore sigs
    componentDidMount() {
        const {
            prescriberAgentSignatureTwo,
            prescriberAgentSignatureThree,
            prescriberAgentSignatureFour,
            confirmDose,
            otherTextShow,
            optionsDose,
            optionsQuantity
        } = this.props.questionOptions; 

        const options = {
            minWidth: 0.5,
        }
        if (prescriberAgentSignatureTwo) {
            this[("prescriberAgentSignatureTwoRef")].fromDataURL(prescriberAgentSignatureTwo, options);
        }
        if (prescriberAgentSignatureThree) {
            this[("prescriberAgentSignatureThreeRef")].fromDataURL(prescriberAgentSignatureThree, options);
        }
        if (prescriberAgentSignatureFour) {
            this[("prescriberAgentSignatureFourRef")].fromDataURL(prescriberAgentSignatureFour, options);
        }
    }

    clearSigCanvas = (refName) => {
        this[(refName + "Ref")].clear();
    }

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[(refName + "Ref")].getTrimmedCanvas().toDataURL()
        })
        this.props.questionAnswer(refName, this[(refName + "Ref")].toDataURL());
    };

    toggleCheckbox = (fields, event, option) => {
        if (event.target.checked) {
            //fields.push(option);
            this.props.questionAnswer(camelCase(event.target.name + option) + "Checked", event.target.checked);
            if(conditionalCheckboxes.indexOf(option) > -1) {
                this.props.questionAnswer(camelCase(option) + "TextShow", true)
            }
        }
        else {
            fields.remove(option);
            this.props.questionAnswer(camelCase(event.target.name + option) + "Checked", event.target.checked);
            if(conditionalCheckboxes.indexOf(option) > -1) {
                this.props.questionAnswer(camelCase(option) + "TextShow", false)
            }
        }
    }

    checkboxGroup = ({ meta, fields, options }) => {
        return (
            <Fragment>
                <label className={meta.error && meta.touched ? "blue-font error" : "blue-font"}>Please confirm diagnosis*</label>
                {options.map(option => {
                    if(conditionalTextareas.indexOf(option) === -1) {
                        if(fields.value && fields.value.indexOf("Dispense: 30-day supply") > -1 && option === "Number of days to be dispensed") {
                            // Do not render number of days to be dispensed if 30 day supply selected
                            return;
                        }
                        return (
                            <div key={option} className="row" style={{marginBottom: "0"}}>   
                                <div className="col">
                                    <Field name={camelCase(option)} type="radio" value={option}>
                                        {({ input, meta }) => {
                                            
                                            return(<Fragment>   
                                                <label className="acadia-checkbox inline-checkboxes" style={{width: "100%"}}>
                                                    <input
                                                        type="checkbox"
                                                        value={input.value}
                                                        onChange={input.onChange}
                                                        key={option}
                                                        onClick={event => this.toggleCheckbox(fields, event, option)} 
                                                        style={{left: 0}}
                                                    />
                                                    <span class="checkmark"></span>
                                                    <span className="checkbox-content">{option}</span>
                                                </label>
                                            </Fragment>);
                                        }}
                                    </Field>
                                </div>
                            </div>   
                        );
                    } else {
                        return(    
                            <Fragment>                   
                                {this.props.questionOptions[option + "Show"] && (
                                    <Field
                                        key={option}
                                        name={camelCase(option)}
                                        component={textareaField}
                                        validate={isRequiredTextarea}
                                    />
                                )}
                            </Fragment>
                        );
                    }  
                })}
                {meta.error && meta.touched && meta.error }
            </Fragment>
        );
    }

    /* TODO: remove conditional field */

    radioGroup = ({ meta, fields, options, group }) => {
        return (
            <Fragment>
                {options.map(option => {
                    if(conditionalTextareas.indexOf(option) === -1) {
                        let radioRender = this.radioRender(fields, fields.name, option, group);
                        return (
                            radioRender
                        );
                    } else {
                        return(                       
                            <div key={option} className="form-group relative" style={{marginBottom: "20px"}}> 
                                {/*this.props.questionOptions[option + "Show"] && (
                                    <Field name={camelCase(option)} component="input" validate={isRequiredTextarea}>
                                        {({ input, meta }) => (
                                            <Fragment>
                                                {meta.error && meta.touched && meta.error }
                                                <textarea className="full-width-input with-checkbox" {...input} />
                                            </Fragment>
                                        )}
                                    </Field>
                                )*/}
                            </div>
                        );
                    }  
                })}
                {meta.error && meta.touched && meta.error }
            </Fragment>
        );
    }

    radioRender = (fields, name, option, group) => {
        return (
            <div className="radio-field" style={{display: 'flex'}}>
            <Field
                name={name}
                component="input"
                type="radio"
                value={option}
                className=""
                id={option+group}
                key={option}
                onClick={event => this.toggleCheckbox(fields, event, option)} 
            />
            <label className="" htmlFor={option+group} dangerouslySetInnerHTML={{__html: option}}>
               
            </label>
        </div>
        )
    }

    disableFieldName(fieldName){
        console.log('disableFieldName:'+ fieldName);
        document.getElementsByName(fieldName).forEach((e) => {
            console.log(fieldName);
            e.value = '';
            e.setAttribute('value', '');
            if(e.disabled){
                e.disabled = false;
                e.classList.remove("input-disable");
            }else{
                e.disabled = true;
                e.classList.add("input-disable");
            }

            if(fieldName == "knownDrugAllergiestName"){
                let no_Allergies = document.getElementById("noAllergies");
                
                console.log('no_Allergies.checked='+no_Allergies.checked);
                if(no_Allergies.checked){
                    no_Allergies.value = 'noAllergies';
                    no_Allergies.setAttribute('value', 'noAllergies');
                    this.props.questionAnswer("noAllergies", "noAllergies");
                    sessionStorage.setItem("noAllergies","noAllergies");
                    no_Allergies.checked = true;
                }else{
                    no_Allergies.value = '';
                    no_Allergies.setAttribute('value', '');
                    this.props.questionAnswer("noAllergies", "");
                    sessionStorage.setItem("noAllergies","");
                    no_Allergies.checked = false;
                }
               
            }else if(fieldName == "concurrentMedicationsName"){
                let no_Medication = document.getElementById("noMedication");
                console.log('no_Medication.checked='+no_Medication.checked);
                
                if(no_Medication.checked){
                    no_Medication.value = 'noMedication';
                    no_Medication.setAttribute('value', 'noMedication');
                    this.props.questionAnswer("noMedication", "noMedication");
                    sessionStorage.setItem("noMedication","noMedication");
                    no_Medication.checked = true;
                }else{
                    no_Medication.value = '';
                    no_Medication.setAttribute('value', '');
                    this.props.questionAnswer("noMedication", "");
                    sessionStorage.setItem("noMedication","");
                    no_Medication.checked = false;
                }
                
            }
           
        });
    }

    focusOnFieldName(fieldName){
        console.log('focusOnFieldName');
        document.getElementsByName(fieldName).forEach((e) => {
            console.log(fieldName);
            e.value = '';
            e.setAttribute('value', '');
            if(fieldName == "knownDrugAllergiestName"){
                let noAllergies = document.getElementById("noAllergies");
                noAllergies.checked = false;
                sessionStorage.setItem("noAllergies", "");
                this.props.questionAnswer("noAllergies", "");
                noAllergies.setAttribute('value', '');
                noAllergies.value = '';
                
            }else if(fieldName == "concurrentMedicationsName"){
                let noMedication = document.getElementById("noMedication");
                noMedication.checked = false;
                this.props.questionAnswer("noMedication", "");
                sessionStorage.setItem("noMedication", "");
                noMedication.setAttribute('value', '');
                noMedication.value = '';
            }
           
        });
    }

    render() {
        const todaysDate = new Date().toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" });
        const { currentStep } = this.props; 
        const {
            confirmDiagnosis,
            ongoingPrescriptionFree,
            ongoingPrescriptionFreeDose,
            numberOfDaysToBeDispensedFree,
            prescriberAgentSignatureTwoDate = todaysDate,
            prescriberAgentSignatureThreeDate = todaysDate,
            prescriberAgentSignatureFourDate = todaysDate,
            prescriberAgentSignatureTwo,
            prescriberAgentSignatureThree,
            prescriberAgentSignatureFour,
            dispenseFourteenDaySupply,
            confirmDose,
            otherTextShow,
            optionsDose,
            optionsQuantity,
            otherPrescriptions,
            otherTextFreeShow,
            otherTextFreeDoseShow,
        } = this.props.questionOptions;
        const dispenseOptions = [
            "Dispense: 30-day supply",
            "Number of refills",
            "numberOfRefillsText",
            "Number of days to be dispensed",
            "numberOfDaysToBeDispensedText"
        ];

       

        const ongoingPrescriptionOptions = [
            "Already provided <br class=\"mobile\"/>prescription",
            "Will e-prescribe once Acadia Connect confirms appropriate pharmacy",
            "New prescription"
            
        ]

        const newPrescriptionOptionsDose = [
            "sig. Take 34 mg capsule orally, once daily",
            "Other<sup class=\"single-dagger\">&dagger;</sup>"
        ]

        const newPrescriptionOptionsQuantity = [
            "Dispense: 30-day supply",
            "# of days to be dispensed"
        ]


        const ongoingPrescriptionFreeOther1 = [
            "E-prescription already sent to RareMed Pharmacy",
            "sig: Take one 34 mg capsule orally, once daily",
            "Other<sup class=\"single-dagger\">&dagger;</sup>",
            "otherTextFree",
        ]

        const ongoingPrescriptionFreeOther = [
            "E-prescription already sent to RareMed Pharmacy",
            "Free 14-day supply with one refill",
        ]



        const ongoingPrescriptionFreeOtherDose = [
            "sig. Take 34 mg capsule orally, once daily",
            "Other<sup class=\"single-dagger\">&dagger;</sup>"
        ]

        

        return (
            <Fragment>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-3">
                        <h3 className="euclid">PRESCRIPTION INFORMATION</h3>
                        <div className="d-inline-block">
                            *<i class="required-field-indication">&nbsp;Indicates required field.</i>
                        </div>
                        
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>
                <div className="row spacer-medium" ref={this.toTop}>&nbsp;</div>
                <div className="row">
                    <div className="col-8 col-sm-8">
                        <Field
                            name="knownDrugAllergiestName"
                            label="Known drug allergies"
                            placeholder=""
                            component={textField}
                           
                        />
                         <OnFocus name="knownDrugAllergiestName">
                            {(value, previous) => {
                               //console.log('OnFocus:knownDrugAllergiestName');
                                this.focusOnFieldName("knownDrugAllergiestName");
                                //console.log('value='+value);
                                //console.log('previous='+previous);
                                //value = ""
                            }}

                         </OnFocus>
                    </div>
                    <div className="col-4 col-sm-4">
                        <label className="acadia-checkbox inline-checkboxes" style={{width: "30px", top: "30px", left:"-30px"}}>
                            
                             
                            <input 
                                id="noAllergies"
                                name="noAllergies"
                                type="checkbox"
                                value=""
                                onChange=""
                                key=""
                                onClick={(e) => this.disableFieldName("knownDrugAllergiestName")}
                                style={{left: 0}}
                                
                                
                            />
                                        
                                    
                            <span class="checkmark"></span>
                            <span className="checkbox-content">None</span>
                        </label>
                    </div>

                   

                </div>
                 
                <div className="row">
                    <div className="col-8 col-sm-8">
                        <Field
                            name="concurrentMedicationsName"
                            label="Concurrent medications"
                            placeholder=""
                            component={textField}
                        />
                        <OnFocus name="concurrentMedicationsName">
                            {(value, previous) => {
                               // console.log('OnFocus:concurrentMedicationsName');
                                this.focusOnFieldName("concurrentMedicationsName");
                                //console.log('value='+value);
                                //console.log('previous='+previous);
                                //value = ""
                            }}

                         </OnFocus>
                    </div>
                    <div className="col-4 col-sm-4">
                         <label className="acadia-checkbox inline-checkboxes" style={{width: "30px", top: "30px", left:"-30px"}}>
                           
                           
                            <input 
                                id="noMedication"
                                name="noMedication"
                                type="checkbox"
                                value=""
                                onChange=""
                                key=""
                               onClick={(e) => this.disableFieldName("concurrentMedicationsName")}
                                style={{left: 0}}
                                
                                
                            />

                    
                                        
                                   
                            <span class="checkmark"></span>
                            <span className="checkbox-content">None</span>
                        </label>
                    </div>
                </div>

               

                <Field name="ongoingPrescription">
                    {({ input, meta }) => (
                        <label className={meta.error && meta.touched ? "font-20 blue-font ongoing-prescription error" : "font-20 blue-font ongoing-prescription"}>NUPLAZID<sup>&reg;</sup> (pimavanserin) ONGOING PRESCRIPTION</label>
                    )}
                </Field>

                <div className="relative form-group ongoing-prescription">
                    <FieldArray
                        name="ongoingPrescription"
                        component={this.radioGroup}
                        options={ongoingPrescriptionOptions}
                        validate={isRequiredSelectionCheckbox}
                        group="pay"
                    />
                    <OnChange name="ongoingPrescription">
                        {(value, previous) => {
                            if(value.indexOf("Already") > -1) {
                                this.props.questionAnswer("otherTextShow", "prescription");
                            }else if(value.indexOf("e-prescribe") > -1){
                                this.props.questionAnswer("otherTextShow", "e-prescribe");
                            }else if(value.indexOf("New") > -1){
                                this.props.questionAnswer("otherTextShow", "new-prescription");
                            }
                        }}
                    </OnChange>
                   
                </div>
                {otherTextShow ==  "prescription" && (
                    <div id="alreadyProvidedPrescriptionTo" className="row">
                        <div className="col-sm">
                            <Field
                                name="alreadyProvidedPrescriptionTo"
                                label=""
                                component={textField}
                                validate=  {isRequiredText} 
                                placeholder="Pharmacy name*"
                            />
                        </div>
                    </div>  
                )}        
                  
                {otherTextShow ==  "new-prescription" && (
                    <Fragment>
                         <Field name="newPrescriptionOptionsDose" style={{ marginTop: "10px"}}>
                            {({ input, meta }) => (
                                <label style={{ fontSize: "15px" }} className={meta.error && meta.touched ? "font-18 blue-font error" : "font-18 blue-font"}>Please confirm dose*</label>
                            )}
                        </Field>

                        <div className="relative form-group" style={{ marginBottom: "20px" }}>
                            <FieldArray
                                name="newPrescriptionOptionsDose"
                                component={this.radioGroup}
                                options={newPrescriptionOptionsDose}
                                validate={isRequiredSelectionCheckbox}
                            
                                group="pay"
                            />
                            <OnChange name="newPrescriptionOptionsDose">
                                {(value, previous) => {
                                    if(value.indexOf("sig") > -1) {
                                        this.props.questionAnswer("optionsDose", "sig");
                                    }else if(value.indexOf("Other") > -1){
                                        this.props.questionAnswer("optionsDose", "Other");
                                    }
                                }}
                            </OnChange>
                        
                        </div>
                       
                        {optionsDose ==  "Other" && (
                            <Fragment>
                                <div id="OtherDose" className="row">
                                    <div className="col-sm">
                                        <Field
                                            name="OtherDose"
                                            label=""
                                            component={textField}
                                            validate={isRequiredText} 
                                            placeholder="Description*"
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        )}

                       

                        <Field name="newPrescriptionOptionsQuantity">
                            {({ input, meta }) => (
                                <label style={{ fontSize: "15px" }} className={meta.error && meta.touched ? "font-18 blue-font error" : "font-18 blue-font"}>Please confirm quantity*</label>
                            )}
                        </Field>

                        <div className="relative form-group">
                            <FieldArray
                                name="newPrescriptionOptionsQuantity"
                                component={this.radioGroup}
                                options={newPrescriptionOptionsQuantity}
                                validate={isRequiredSelectionCheckbox}
                            
                                group="pay"
                            />
                            <OnChange name="newPrescriptionOptionsQuantity">
                                {(value, previous) => {
                                    if(value.indexOf("30-day supply") > -1) {
                                        this.props.questionAnswer("optionsQuantity", "30-day supply");
                                    }else if(value.indexOf("dispensed") > -1){
                                        this.props.questionAnswer("optionsQuantity", "dispensed");
                                    }
                                }}
                            </OnChange>
                        
                        </div>

                        <div id="ConfirmRefill" className="row"  style={{ marginTop: "1s0px" }}>
                            <div className="col-sm">
                                <Field
                                    
                                    name="ConfirmRefill"
                                    label="Please confirm # of refills*"
                                    component={textField}
                                    validate={isRequiredText} 
                                    placeholder=""
                                />
                            </div>
                        </div>


                        {optionsQuantity ==  "dispensed" && (
                            <Fragment>
                                <div id="nbrOdDays" className="row">
                                    <div className="col-sm">
                                        <Field
                                            name="nbrOdDays"
                                            label=""
                                            component={textField}
                                            validate={isRequiredText} 
                                            placeholder="# of days*"
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        )}
                                
                                
                    </Fragment>
                )}
                

                
               

                {/* <div className="relative form-group iphone11-checkboxes-left-15px" style={{ marginTop: "0px", marginBottom: "20px" }}>
                        <Field
                            className="form-control full-width-input"
                            type="checkbox"
                            name="ePrescribe"
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <div className="row">
                                        <div className="col-2 col-md-1">
                                            <label className="acadia-checkbox">
                                                <input ref={this.ePrescribe} {...input} type="checkbox" style={{left: "0px"}} />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-10 col-md-11 pl-0">
                                            <label className="mobile-label">
                                                <span className="hipaa-agree">Will e-prescribe once Acadia Connect confirms appropriate pharmacy</span>
                                            </label>
                                        </div>
                                    </div>
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                        <OnChange name="ePrescribe">
                            {(value, previous) => {
                                this.props.questionAnswer("hipaa", value);
                                this.setState({
                                    ...this.state,
                                    patientSignature: value,
                                    personalRepresentative: !value
                                });
                            }}
                        </OnChange>
                    </div> */}

                <div className="row spacer-small">&nbsp;</div>
                <div className="row spacer-small">&nbsp;</div>
                <p>Avoid the use of NUPLAZID with drugs that also increase the QT interval and in patients with risk factors for prolonged QT interval.</p> 
                <p>The recommended dose of NUPLAZID when coadministered with strong CYP3A4 inhibitors (eg, ketoconazole) is 10 mg, taken orally as one tablet once&nbsp;daily.</p>
                <p>Avoid concomitant use of strong or moderate CYP3A4 inducers with NUPLAZID.</p>
                 
                {otherTextShow ==  "new-prescription" && (

                    <Fragment>    
                         <p><sup class="single-dagger">&dagger;</sup>See <a href="https://assets.ctfassets.net/hac178phwz3f/24ffMdK7RU4vkZuu6pGhAA/fd70a73c40f7f76a13a9fec8e562f21d/nuplazid-prescribing-Information.pdf" target="_blank" rel="noopener noreferrer">Full Prescribing Information</a>, including Boxed WARNING, for dosing recommendations (including drug/drug interactions).</p>
   
                        <div className="hipaa form-group signature">
                            <Field name="prescriberAgentSignatureTwo" defaultValue={prescriberAgentSignatureTwo} component="input" validate={isRequiredSignature}>
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.error && meta.touched ? "error" : "no" } htmlFor="prescriberAgentSignatureTwo">Prescriber signature*</label> 
                                    </Fragment>
                                )}
                            </Field>
                            <div className="relative">
                                
                                <SignatureCanvas 
                                penColor='black' 
                                canvasProps={{height: 200, className: 'sig-canvas canvas-with-border'}} 
                                onEnd={() => {
                                    this.storeSigData("prescriberAgentSignatureTwo");
                                    this.storeSigData("prescriberAgentSignatureThree");
                                    this.storeSigData("prescriberAgentSignatureFour");
                                }}
                                ref={(ref) => { this.prescriberAgentSignatureTwoRef = ref }} 
                                clearOnResize={false} 
                                />
                                
                                <button type="button" className="canvas-clear" onClick={() => this.clearSigCanvas("prescriberAgentSignatureTwo")}>CLEAR</button>
                                <Field name="prescriberAgentSignatureTwo" defaultValue={prescriberAgentSignatureTwo} component="input">
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                           
                                        </Fragment>
                                    )}
                                </Field>
                                <Field name="prescriberAgentSignatureThree" defaultValue={prescriberAgentSignatureThree} component="input">
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                           
                                        </Fragment>
                                    )}
                                </Field>
                                <Field name="prescriberAgentSignatureFour" defaultValue={prescriberAgentSignatureFour} component="input">
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <Field name="prescriberAgentSignatureThreeDate"
                                        component="input"
                                        defaultValue={todaysDate}
                                    >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <Field name="prescriberAgentSignatureFourDate"
                                        component="input"
                                        defaultValue={todaysDate}
                                    >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                            </div>
                            <SignatureDate forDate="prescriberAgentSignatureTwo"/>
                        </div>
                    </Fragment>
                )}
                   {otherTextShow ==  "new-prescription" && (
                        <div className="hipaa form-group substitution">
                            <h3>Substitution Permitted (optional)</h3>
                            <label htmlFor="prescriberAgentSignature">Prescriber signature</label>
                            <div className="relative">
                                <SignatureCanvas 
                                penColor='black' 
                                canvasProps={{height: 200, className: 'sig-canvas canvas-with-border'}} 
                                onEnd={() => this.storeSigData("prescriberAgentSignatureThree")} 
                                ref={(ref) => { this.prescriberAgentSignatureThreeRef = ref }} 
                                clearOnResize={false} 
                                />
                                <button type="button" className="canvas-clear" onClick={() => this.clearSigCanvas("prescriberAgentSignatureThree")}>CLEAR</button>
                                <Field name="prescriberAgentSignatureThree" defaultValue={prescriberAgentSignatureThree} component="input">
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <SignatureDate forDate="prescriberAgentSignatureThree"/>
                            </div>
                </div>
                   )}
                 <div className="hipaa free-14-day">
                     <h3>Free 14-day Supply of NUPLAZID (optional)</h3>
                     <br class="desktop"/>
                    <p>Note: Limited to a 14-day supply per fill (only for patients diagnosed with <br class="desktop" />hallucinations and delusions associated with Parkinson's disease psychosis)</p>
                    <div className="relative">
                        <FieldArray
                            name="ongoingPrescriptionFree"
                            component={this.radioGroup}
                            options={ongoingPrescriptionFreeOther}
                            /*validate={conditionallyRequiredSelectionCheckbox(numberOfDaysToBeDispensedFree || ongoingPrescriptionFree || numberOfDaysToBeDispensedFree || prescriberAgentSignatureFour || prescriberAgentSignatureFourDate || prescriberAgentSignatureFour ? 1 : 0)}*/
                            key={numberOfDaysToBeDispensedFree || prescriberAgentSignatureFour || prescriberAgentSignatureFourDate || prescriberAgentSignatureFour ? 1 : 0}
                            group="free"
                        />
                        <OnChange name="ongoingPrescriptionFree">
                            {(value, previous) => {
                                this.props.questionAnswer();
                                if(value.indexOf("E-prescription") > -1) {
                                    this.props.questionAnswer("otherTextFreeShow", true);                               
                                } else {
                                    this.props.questionAnswer("otherTextFreeShow", false);
                                }
                            }}
                        </OnChange>

                        {(otherTextFreeShow == false) && (
                             <Fragment>
                                <div className="relative">
                                    <Field name="ongoingPrescriptionFreeOptionsDose">
                                        {({ input, meta }) => (
                                            <label style={{ fontSize: "15px" }} className={meta.error && meta.touched ? "font-18 blue-font error" : "font-18 blue-font"}>Please confirm dose*</label>
                                        )}
                                    </Field>
                                    <FieldArray
                                        name="ongoingPrescriptionFreeOtherDose"
                                        component={this.radioGroup}
                                        options={ongoingPrescriptionFreeOtherDose}
                                        /*validate={conditionallyRequiredSelectionCheckbox(numberOfDaysToBeDispensedFree || ongoingPrescriptionFree || numberOfDaysToBeDispensedFree || prescriberAgentSignatureFour || prescriberAgentSignatureFourDate || prescriberAgentSignatureFour ? 1 : 0)}*/
                                        key={numberOfDaysToBeDispensedFree || prescriberAgentSignatureFour || prescriberAgentSignatureFourDate || prescriberAgentSignatureFour ? 1 : 0}
                                        group="free"
                                    />
                                    <OnChange name="ongoingPrescriptionFreeOtherDose">
                                        {(value, previous) => {
                                            this.props.questionAnswer();
                                            if(value.indexOf("sig") > -1) {
                                                this.props.questionAnswer("otherTextFreeDoseShow", true);
                                            } else {
                                                this.props.questionAnswer("otherTextFreeDoseShow", false);
                                            }
                                        }}
                                    </OnChange>
                                </div>

                                {(otherTextFreeDoseShow == false) && (
                                    <Fragment>
                                         <div id="otherDiagnosis" className="row">
                                            <div className="col-sm">
                                                <Field
                                                    name="otherDiagnosis"
                                                    label=""
                                                    component={textField}
                                                    validate={isRequiredText} 
                                                    placeholder="Description*"
                                                
                                                />
                                            </div>
                                        </div>
                                    
                                    </Fragment>
                                )}
                               
                            </Fragment>
                         )}
                        
                    
                    </div>
                    <div className="row spacer-small">&nbsp;</div>
                    <p className="text-left">Acadia Connect may send a second free <span className="nobr">14-day</span> supply if extra time is needed.</p>
                    <div className="row spacer-small">&nbsp;</div>
                   
                   
                    
                    <p className="text-left">Note: Free 14-day Supply of NUPLAZID to be dispensed by RareMed Pharmacy. NUPLAZID will only be dispensed and delivered to facilities that accept free product.</p>
                    {(otherTextFreeShow == false) && (
                        <div>
                            <p className="font-15 blue-font">Prescriber signature*</p>
                            <SignatureCanvas 
                            penColor='black' 
                            canvasProps={{height: 200, className: 'sig-canvas'}} 
                            onEnd={() => this.storeSigData("prescriberAgentSignatureFour")} 
                            ref={(ref) => { this.prescriberAgentSignatureFourRef = ref }} 
                            clearOnResize={false} 
                            />
                            <button type="button" className="canvas-clear" style={{/*bottom: '37px', right: '33px'*/}} onClick={() => this.clearSigCanvas("prescriberAgentSignatureFour")}>CLEAR</button>
                            <Field 
                                name="prescriberAgentSignatureFour"
                                defaultValue={prescriberAgentSignatureFour}
                                component="input"
                                validate={isRequiredSignature}
                                /*validate={conditionallyRequiredSignature(ongoingPrescriptionFree || numberOfDaysToBeDispensedFree || prescriberAgentSignatureFour || prescriberAgentSignatureFourDate || prescriberAgentSignatureFour ? 1 : 0)}*/
                                key={ongoingPrescriptionFree || numberOfDaysToBeDispensedFree || prescriberAgentSignatureFour || prescriberAgentSignatureFourDate || prescriberAgentSignatureFour ? 1 : 0}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                      )}

                    {(otherTextFreeShow == false) && (
                         <Fragment>    
                            <SignatureDate forDate="prescriberAgentSignatureFour"/>
                        </Fragment>    
                    )}
                     {( otherTextFreeShow == false) && (
                         <Fragment>    
                            <p><sup class="single-dagger">&dagger;</sup>See <a href="https://www.nuplazidhcp.com/pdf/nuplazid-prescribing-information.pdf" target="_blank" rel="noopener noreferrer">Full Prescribing Information</a>, including Boxed WARNING, for dosing recommendations (including drug/drug interactions).</p>
                         </Fragment>    
                    )}
                </div>
                
              
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
}
  
export default connect(mapStateToProps, actions)(Step4);